import React, { useEffect, useRef, useState } from "react";
import {
  motion,
  useInView,
  useMotionValue,
  useTransform,
  animate,
} from "framer-motion";
import "./ByTheNumbers.css";

const STATS = [
  {
    value: 5000,
    suffix: "+",
    label: "Placements Delivered",
    body: "Kenyan workers earning in the Middle East. Employers building reliable teams.",
  },
  {
    value: 50,
    suffix: "+",
    label: "Partner Employers",
    body: "Companies that return because results matter more than promises.",
  },
  {
    value: 17,
    suffix: "",
    label: "Industries Covered",
    body: "From construction to hospitality to healthcare. Same rigor, every sector.",
  },
];

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px" });
  const mv = useMotionValue(0);
  const t = useTransform(mv, (v) => Math.round(v).toLocaleString());
  const [text, setText] = useState("0");

  useEffect(() => {
    const u = t.on("change", (v) => setText(v));
    return u;
  }, [t]);

  useEffect(() => {
    if (!inView) return;
    const ctrl = animate(mv, value, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
    });
    return () => ctrl.stop();
  }, [inView, mv, value]);

  return (
    <span ref={ref}>
      {text}
      {suffix}
    </span>
  );
}

export default function ByTheNumbers() {
  return (
    <section className="nums">
      <div className="container">
        <div className="nums__header">
          <span className="eyebrow">The Scale</span>
          <h2 className="nums__title">
            Numbers that reflect{" "}
            <span className="nums__title-accent">trust earned.</span>
          </h2>
        </div>

        <div className="nums__grid">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              className="nums__cell"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{
                duration: 0.6,
                delay: i * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <div className="nums__value">
                <Counter value={s.value} suffix={s.suffix} />
              </div>
              <div className="nums__label">{s.label}</div>
              <p className="nums__body">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
